import {IndicatorType, Locations, LocationsArrayExceptNSW } from 'src/app/indicator/constraints';
import {Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {IndicatorState} from 'src/app/indicator/indicator.state';
import {Util} from 'src/app/shared/util';
import {DialogComponent} from '../dialog/dialog.component';

@Component({
  selector: "app-sortable-checkbox-menu",
  templateUrl: "./sortable-checkbox-menu.component.html",
  styleUrls: ["./sortable-checkbox-menu.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class SortableCheckboxMenuComponent implements OnInit {
  // @ViewChild("onboardingDialog", {static: true}) onboardingDialog: DialogComponent;

  titleLabel = "Compare:";
  title: string;
  items: string[] = [];
  selectedItems: string[] = [];
  locationChartLabelByName: {[key: string]: string} = {};
  isPresumIndicator: boolean = false;
  showTip: boolean = false;
  menuIsVisible: boolean = false;
  onboardTimer: any;

  @Output() itemsSelected: EventEmitter<string[]> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {}

  onStateUpdated(state: IndicatorState) {
    this.selectedItems = Util.copy(state.Compare);
    this.isPresumIndicator = state.Meta?.typeId === IndicatorType.Presummarised;
    this.setLocationChartLabelMap(state);
    this.items = this.getCompareOptions(state);

    // Commenting out onboarding dialog and all related code (#122701). This can be retrieved if required later.
    // this.triggerOnboarding(state);

    this.updateTitle();
  }

  private setLocationChartLabelMap(state: IndicatorState) {
    if (!this.isPresumIndicator) {
      this.locationChartLabelByName = {};
      return;
    }
    this.locationChartLabelByName = {};
    (state.Meta?.locations ?? []).forEach((location: any) => {
      if (!location?.name) {
        return;
      }
      this.locationChartLabelByName[location.name] = Util.deslugify(location.chartLabel || location.name);
    });
  }

  // Compare options will contain groups as well as Locations except for NSW
  getCompareOptions(state: IndicatorState): string[] {
    let validOptions: string[] = [];
    const isPresum = state.Meta?.typeId === IndicatorType.Presummarised;

    if (state.Location !== Locations.NSW && !isPresum) {
      validOptions.push(state.Location);
    }

    validOptions.push(...state.Groups);

    let sortedOptions: string[] = [];

    // for presum indicator, clear the items if the viewset changes so that the order of the compare options are up to date
    // if viewset changes, then the groups array and the items array will not match
    if (isPresum && !this.arraysEqual(state.Groups, this.items)) {
      this.items = [];
    }

    if (this.items.length > 0) {
      // keep existing order of items
      sortedOptions.push(...this.items);
    } else {
      // sort items according to order of selected items
      sortedOptions.push(...this.selectedItems);
    }

    // Filter out options that are no longer valid
    sortedOptions = sortedOptions.filter(item => validOptions.includes(item));

    // remaining items will be appended last
    validOptions.forEach(item => !sortedOptions.includes(item) && sortedOptions.push(item));

    // Remove locations if NSW
    if (state.Location === Locations.NSW) {
      sortedOptions = sortedOptions.filter(option => !LocationsArrayExceptNSW.includes(option));
    }

    return sortedOptions;
  }

  private arraysEqual(a: string[], b: string[]): boolean {
    if (a.length !== b.length) return false;

    const aSorted = [...a].sort();
    const bSorted = [...b].sort();

    return aSorted.every((val, i) => val === bSorted[i]);
  }

  // triggerOnboarding(state: IndicatorState) {
  //   const onboarded = localStorage.getItem("onboarding.compare");

  //   if (!onboarded && !this.showTip && Object.entries(state.Filter).length > 1) {
  //     for (let [key, filters] of Object.entries(state.Filter)) {
  //       if (filters && filters.length > 1) {
  //         this.onboardTimer = setTimeout(() => {
  //           this.onboardingDialog.open();
  //         }, 2000);
  //         return;
  //       }
  //     }
  //   }
  // }

  deslugify(item: string) {
    if (!this.isPresumIndicator) {
      return Util.deslugify(item);
    }

    return this.locationChartLabelByName[item] || Util.deslugify(item);
  }

  updateTitle() {
    const sorted = this.items.filter((x) => this.selectedItems.indexOf(x) >= 0);
    const displayTitle = sorted
      .reduce((result: string[], current: string) => {
        result.push(this.deslugify(current));
        return result;
      }, [])
      .join(", ");
    this.title = displayTitle.trim();
    if (this.title == "") {
      this.title = "None selected";
    }
    return sorted;
  }

  ActionChanges() {
    // const sorted = this.items.filter((x) => this.selectedItems.indexOf(x) >= 0);
    // this.title = sorted.join(', ');
    const sorted = this.updateTitle();
    this.itemsSelected.emit(sorted);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
    this.ActionChanges();
    this.menuIsVisible = this.showTip;
  }

  checkIfSelected(item: string) {
    return this.selectedItems.includes(item);
  }

  onToggleButtonClick(event: any) {
    if (this.onboardTimer) {
      clearTimeout(this.onboardTimer);
    }

    if (!this.showTip) {
      this.menuIsVisible = !this.menuIsVisible;
    }
  }

  onItemClicked(event: Event, id: any) {
    event.preventDefault();
    if (this.selectedItems.includes(id)) {
      this.selectedItems = Util.remove(this.selectedItems, id);
    } else {
      this.selectedItems.push(id);
    }
    // TODO notify parent
    this.menuIsVisible = this.showTip;
    this.ActionChanges();
  }

  // tryItHandler() {
  //   this.onboardingDialog.close();
  //   this.menuIsVisible = true;
  //   this.showTip = true;
  // }

  // gotItHandler() {
  //   localStorage.setItem("onboarding.compare", "true");
  //   this.onboardingDialog && this.onboardingDialog.close();
  //   this.menuIsVisible = false;
  //   this.showTip = false;
  // }

}
